import script from "./SelectorSimpler.vue?vue&type=script&setup=true&lang=ts"
export * from "./SelectorSimpler.vue?vue&type=script&setup=true&lang=ts"

import "./SelectorSimpler.vue?vue&type=style&index=0&id=82bd5ad2&scoped=true&lang=postcss"

import exportComponent from "/var/www/rentasdhelos.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-82bd5ad2"]])

export default __exports__